export const EXAM_HINT_OPTIONS_MAP = {
  YES: { label: "Yes", value: true },
  NO: { label: "No", value: false },
};

export const EXAM_HINT_OPTIONS = [
  EXAM_HINT_OPTIONS_MAP.YES,
  EXAM_HINT_OPTIONS_MAP.NO,
];
